export default __webpack_public_path__ + "static/media/image-holder.368b8954.jpeg";